import React, { FC } from 'react'
import { Icon } from '@wmgtech/legato'

import { User } from 'shared/__gql-types'
import { IProjectMetricItemProps } from './ProjectMetrics.props'

export const ProjectMetricItem: FC<IProjectMetricItemProps> = ({ iconName, title, value = 'N/A' }) => {
  return (
    <dl className="project-metrics__item">
      <dt className="project-metrics__metrics">
        <Icon name={iconName} />
        {title}
      </dt>
      <dd>{value}</dd>
    </dl>
  )
}

type OwnerValueProps = {
  user: Partial<User>
}
export const OwnerValue:FC<OwnerValueProps> = ({ user }) => (
  <a className="link" href={`mailto:${user.email}`} data-test="project_detail-project_owner">{user.first_name} {user.last_name}</a>
)
